'use strict';

import Swiper from 'swiper';
import { debounce } from 'lodash';
import parseBoolean from 'utils/parse-boolean';

const SELECTOR = '.js-slideshow';

(function () {
    const elements = document.querySelectorAll(SELECTOR);

    if (!elements.length) {
        return;
    }

    elements.forEach(element => {
        const slider = element.querySelector('.swiper-container');

        const effect = element.dataset.slideshowEffect || 'slide';
        const speed = parseInt(element.dataset.slideshowSpeed, 10) || 2000;
        const delay = parseInt(element.dataset.slideshowDelay, 10) || 0;
        const direction = element.dataset.slideshowDirection || 'horizontal';
        const autoplay = parseBoolean(element.dataset.slideshowAutoplay, false);
        const autoplayDelay = parseInt(element.dataset.slideshowAutoplayDelay, 10);
        const paginationType = element.dataset.slideshowPaginationType || 'bullets';

        const prevElement = element.querySelector(
            element.dataset.slideshowPrevSelector || '.swiper-button__prev'
        );

        const nextElement = element.querySelector(
            element.dataset.slideshowNextSelector || '.swiper-button__next'
        );

        const paginationElement = element.querySelector(
            element.dataset.slideshowPaginationSelector || '.swiper-pagination'
        );

        const config = {
            slidesPerView: 'auto',
            direction: direction,
            effect: effect,
            speed: speed,
            loop: true,
            watchOverflow: true,
            simulateTouch: false
        }

        if (autoplay && autoplayDelay) {
            config.autoplay = {
                delay: autoplayDelay,
                disableOnInteraction: false,
            }
        } else if (autoplay) {
            config.autoplay = true;
        }

        if (prevElement && nextElement) {
            config.freeMode = true;
            config.freeModeMomentum = false;
            config.freeModeSticky = true;
            config.simulateTouch = true;
            config.navigation = {
                prevEl: prevElement,
                nextEl: nextElement,
            }
        }

        if (paginationElement) {
            config.pagination = {
                el: paginationElement,
                type: paginationType,
                clickable: true,
            }
        }

        setTimeout(() => {
            let swiper = new Swiper(slider, config);

            window.addEventListener('resize', debounce(() => {
                const realIndex = swiper.realIndex;

                swiper.destroy();

                if (config.autoplay) {
                    config.autoplay = true;
                }

                config.initialSlide = realIndex;

                swiper = new Swiper(slider, config);
            }, 100), false);
        }, delay);
    });
}());
